import AppRoutes from "Routes";
import { SidebarProvider } from "utils/helpers/SidebarContext";
import { UserProvider } from "utils/helpers/UserContext";
import SnackbarContainer from "utils/snack_bar/SnackbarContainer";

function App() {
  return (
    <SidebarProvider>
      <div className="App bg-primary-50">
        <UserProvider>
          <AppRoutes />
          <SnackbarContainer />
        </UserProvider>
      </div>
    </SidebarProvider>
  );
}

export default App;
